import InputField from "../../../component/input-field";
import Table from "../../../component/table";

// Redux
import { useSelector } from "react-redux"

const BookingDetails = ({ openTab }) => {

  const { customeFields, units } = useSelector( state => state.performance );

  return (
    <div id="tabAdded" className={openTab === 2 ? "block space-y-4 py-4" : "hidden"}>
      <h4 className="text-base font-bold leading-6 tracking-tight px-3 py-1">Booking Details</h4>
      <div className="flex flex-wrap mb-6 px-3">
        {Object.keys(customeFields).length !== 0 ? (
          Object.keys(customeFields).map((ele) => {
            return (
              <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <InputField type="text" label={ele} wrapperClass="mb-2" value={customeFields[ele]} disabled />
              </div>
            );
          })
        ) : (
          <h2>No booking details available.</h2>
        )}
      </div>
      <div className="mt-6 text-base font-bold leading-6 tracking-tight px-3 py-1">Asset Details</div>
      <div className="flex flex-wrap px-3">
        <div className="border w-full bg-white rounded-md">
          <Table>
            <tr className="h-11">
              <th className="py-1">Asset Type</th>
              <th className="py-1">Asset Quantity</th>
            </tr>
            {units ? units.map((item) => (
              <tr key={item.id} className="h-11">
                <td className="text-center text-gray-600">{item.asset_type}</td>
                <td className="text-center text-gray-600">{item.quantity}</td>
              </tr>
            )) : null}
          </Table>
        </div>
      </div>
    </div>
  );
};
export default BookingDetails;
